import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out
 * of the slice's reducers: they trigger side effects, not state transitions (the
 * saga owns the resulting `load*` / `save*` / `archive*` transitions).
 */

/** Load the admin by id (dispatched on mount). */
export const loadRequested = createAction<string>('editAdministrator/loadRequested');

/** Persist the current draft (dispatched on Save). */
export const submitRequested = createAction('editAdministrator/submitRequested');

/** Archive (true) or unarchive (false) the loaded admin. */
export const archiveToggleRequested = createAction<boolean>(
  'editAdministrator/archiveToggleRequested',
);
